import { render } from "./GroupDetailForm.vue?vue&type=template&id=e3b12f18"
import script from "./GroupDetailForm.vue?vue&type=script&lang=js"
export * from "./GroupDetailForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__